export const normalizeVueSelectOptions = (options) => {
  if (!Array.isArray(options)) {
    return [];
  }

  return options.filter((option) => option !== null && option !== undefined);
};
